module.exports = __webpack_public_path__ + "img/comerciocity-logo.e0805ee3.png";